export const toSlug = (value: string): string =>
  String(value || "")
    .trim()
    .toLowerCase()
    .replace(/&/g, " and ")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");

export const getFileName = (url: string, fallback: string): string => {
  try {
    const last = String(url || "").split("/").pop() || "";
    const clean = decodeURIComponent(last.split("?")[0]);
    return clean || `${toSlug(fallback)}.pdf`;
  } catch (e) {
    return `${toSlug(fallback)}.pdf`;
  }
};

export const downloadFile = async (url: string, fileName: string) => {
  try {
    const response = await fetch(url);
    if (!response.ok) throw new Error(String(response.status));

    const blob = await response.blob();
    const objectUrl = window.URL.createObjectURL(blob);
    const link = document.createElement("a");

    link.href = objectUrl;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    window.setTimeout(() => window.URL.revokeObjectURL(objectUrl), 2000);
  } catch (e) {
    window.open(url, "_blank");
  }
};
